import { render, staticRenderFns } from "./modalCancelarPost.vue?vue&type=template&id=b3004052&scoped=true&"
import script from "./modalCancelarPost.vue?vue&type=script&lang=js&"
export * from "./modalCancelarPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3004052",
  null
  
)

export default component.exports